import { breakpoints } from '@gassan-ui'
import { rem } from 'polished'
import styled, { css } from 'styled-components'
import { color, display, space, typography } from 'styled-system'
import { BaseLink, colorVariants } from '.'
import { regular } from '../Typography/Text'
import { allStyledSystemFunctions } from '../Typography/config'

interface StyledLinkProps extends BaseLink {}

export const Link = styled.a<StyledLinkProps>`
  ${regular};
  font-size: ${rem(14)};
  color: ${(p) => colorVariants[p.variant]};
  transition: all 0.2s ease-in-out;
  padding: 0;
  outline: 0;
  align-items: center;
  ${allStyledSystemFunctions};
  ${space};
  ${typography};
  ${display};
  ${color};

  ${(p) =>
    p['disabled']
      ? css`
          cursor: not-allowed;
        `
      : css`
          &:hover {
            opacity: 0.3;
          }
        `}

  @media screen and (min-width: ${breakpoints.medium}) {
    font-size: 1rem;
  }
`
